import {
  fromTimeZoneToUTC,
  fromUTCToTimeZone,
  toDate,
  toISOString,
  dateFNS,
  rangePresets,
} from '@gogame/intl-ts';

import { PERIOD_PRESETS } from './presets';

function getLastPeriodDate(period) {
  let lastPeriodDay;
  let constKey = period.length === 1 ? period[0] : null;
  if (constKey) {
    const preset = PERIOD_PRESETS.find(({ key }) => {
      return key[0] === constKey;
    });
    if (!preset) {
      throw new Error(
        `Preset "${constKey}" not found for calc getLastPeriodDate`
      );
    }

    lastPeriodDay = dateFNS.startOfDay(
      fromUTCToTimeZone(toDate(preset.value[1]))
    );
  } else {
    lastPeriodDay = dateFNS.startOfDay(fromUTCToTimeZone(toDate(period[1])));
  }
  return lastPeriodDay;
}
export const getPayToByPeriod = (period) => {
  const lastPeriodDay = getLastPeriodDate(period);
  let payTo = dateFNS.startOfDay(
    fromUTCToTimeZone(toDate(rangePresets.YESTERDAY.value[0]))
  );

  if (lastPeriodDay > payTo) {
    payTo = lastPeriodDay;
  }

  return toISOString(fromTimeZoneToUTC(payTo));
};

export const getPayToForCompare = (period) => {
  return toISOString(fromTimeZoneToUTC(getLastPeriodDate(period)));
};

export const getPrevious = (value, timeZone = 'utc') => {
  const normalizedValue = toDate(value);

  let [start, end] = fromUTCToTimeZone(normalizedValue, timeZone);

  if (dateFNS.isFirstDayOfMonth(start) && dateFNS.isLastDayOfMonth(end)) {
    const prevMonth = dateFNS.subMonths(start, 1);
    start = dateFNS.startOfMonth(prevMonth);
    end = dateFNS.endOfMonth(prevMonth);
  } else {
    const diff = Math.abs(dateFNS.differenceInDays(start, end)) + 1;
    start = dateFNS.subDays(start, diff);
    end = dateFNS.subDays(end, diff);
  }

  return toISOString(fromTimeZoneToUTC([start, end], timeZone));
};
